// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chingling: PokeData = {
  "id": 433,
  "name": "chingling",
  "height": 2,
  "weight": 6,
  "base_experience": 57,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "double-edge",
    "growl",
    "confusion",
    "hypnosis",
    "recover",
    "uproar",
    "yawn",
    "astonish",
    "extrasensory",
    "last-resort",
    "ominous-wind",
    "entrainment"
  ],
  "moves": [
    "tackle",
    "growl",
    "psy-ball",
    "psy-pulse",
    "synchronize",
    "psychic-fangs",
    "psychic",
    "healing-wish",
    "psywave",
    "future-sight",
    "psychic-terrain",
    "calm-mind",
    "zen-headbutt"
  ],
  "evolution_chain": {
    "id": 184,
    "item": {
      "name": "pure-incense"
    },
    "species": [
      {
        "name": "chingling",
        "order": 387,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "chimecho",
        "order": 388,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 433,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 45,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
